import { useState } from 'react';
import { Colors, Animation } from '../../../theme';
import { isolateComponent, labelStyles, withModifier, } from '@zapier/style-encapsulation';
import { uniqueId } from '../../../utils/uniqueId';
const colorVariations = {
    gray: {
        base: {
            borderColor: Colors.gray60,
        },
        check: {
            borderColor: Colors.ocean,
        },
        hover: {
            borderColor: Colors.ocean,
        },
        focus: {
            backgroundColor: Colors.ocean,
            borderColor: Colors.ocean,
        },
    },
    white: {
        base: {
            borderColor: Colors.white,
        },
        check: {
            borderColor: Colors.white,
        },
        hover: {
            borderColor: Colors.white,
        },
        focus: {
            backgroundColor: Colors.white,
            borderColor: Colors.white,
        },
    },
};
const Styles = labelStyles('Indicator', {
    input: (props) => [
        {
            position: 'relative',
            appearance: 'none',
            display: 'inline-block',
            borderStyle: 'solid',
            borderWidth: 2,
            borderRadius: '50%',
            width: 10,
            height: 10,
            cursor: 'pointer',
            transitionDuration: Animation.transitionDuration,
            transitionProperty: 'border-width, border-color',
            transitionTimingFunction: Animation.transitionTimingFunction,
            '&::before': {
                position: 'absolute',
                height: 16,
                width: 16,
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                borderRadius: '50%',
                pointerEvents: 'none',
                content: '""',
                opacity: 0,
                transitionDuration: Animation.transitionDuration,
                transitionProperty: 'opacity',
                transitionTimingFunction: Animation.transitionTimingFunction,
            },
            '&:checked': {
                borderWidth: 5,
            },
            '&:focus': {
                '&::before': {
                    opacity: 0.25,
                },
            },
            '&:hover': {
                borderWidth: 5,
            },
        },
        withModifier(props.color, {
            borderColor: colorVariations[props.color].base.borderColor,
            '&::before': {
                backgroundColor: colorVariations[props.color].focus.backgroundColor,
            },
            '&:checked': {
                borderColor: colorVariations[props.color].check.borderColor,
            },
            '&:focus': {
                borderColor: colorVariations[props.color].focus.borderColor,
            },
            '&:hover': {
                borderColor: colorVariations[props.color].hover.borderColor,
            },
        }),
    ],
    root: (props) => [
        {
            display: 'grid',
            gap: 6,
            gridTemplateColumns: `repeat(${props.count}, 10px)`,
        },
    ],
});
export const Indicator = (props) => {
    const { count, selectedIndex, onChangeIndex, ariaLabel, noun } = props;
    const [name] = useState(uniqueId('Indicator-'));
    const handleOnChange = ({ target }) => {
        const { value } = target;
        const index = parseInt(value, 10);
        onChangeIndex(index);
    };
    return (isolateComponent("div", { "aria-label": ariaLabel, css: Styles.root(props), role: "radiogroup" }, Array.from({ length: count }).map((_, i) => (isolateComponent("input", { "aria-label": `${noun} ${i + 1}`, checked: i === selectedIndex, css: Styles.input(props), key: `bubble-${i}`, name: name, onChange: handleOnChange, type: "radio", value: i })))));
};
Indicator.defaultProps = {
    noun: 'page',
};
//# sourceMappingURL=Indicator.js.map
// @zapier/design-system@6.1.0 (fd86aa2ab)
